import type { Status } from '@/entities/user/model/userSchema';
import type { EmployeeDomainData } from '@/entities/employee/api/hooks';

export const stLabel: Record<string, string> = {
  ok: 'Все показатели в норме',
  warn: 'Есть предупреждения',
  err: 'Требует внимания',
};

export const medLabel: Record<string, string> = {
  ok: 'Пройден',
  warn: 'Истекает',
  err: 'Просрочен',
  info: 'Назначен',
};

export const internLabel: Record<string, string> = {
  active: 'В процессе',
  done: 'Завершена',
};

export type EmployeeModuleBlock = {
  title: string;
  status: Status;
  rows: [string, string][];
  linkTo: string;
};

export function buildEmployeeModuleBlocks(employeeId: string, domain: EmployeeDomainData): EmployeeModuleBlock[] {
  const internStatus: Status = domain.internship.status === 'active' ? 'info' : 'ok';

  return [
    {
      title: 'Медосмотры',
      status: domain.medical.status,
      linkTo: `/medical?employeeId=${employeeId}`,
      rows: [
        ['Последний', domain.medical.lastDate],
        ['Следующий', domain.medical.nextDate],
        ['Результат', domain.medical.result],
        ['Статус', medLabel[domain.medical.status]],
      ],
    },
    {
      title: 'Обучение',
      status: domain.training.briefingStatus,
      linkTo: `/training?employeeId=${employeeId}`,
      rows: [
        ['Последний инструктаж', domain.training.lastDate],
        ['Следующий', domain.training.nextDate],
        ['Удостоверение', domain.training.certNumber],
        ['Действует до', domain.training.certExpiry],
      ],
    },
    {
      title: 'Стажировка',
      status: internStatus,
      linkTo: `/training?employeeId=${employeeId}`,
      rows: [
        ['Статус', internLabel[domain.internship.status]],
        ['Наставник', domain.internship.mentor],
        ['Завершение', domain.internship.endDate],
        ['Допуск', domain.internship.admitted ? 'Да' : 'Нет'],
      ],
    },
    {
      title: 'СОУТ',
      status: domain.sout.status,
      linkTo: `/sout?employeeId=${employeeId}`,
      rows: [
        ['Рабочее место', domain.workplaceId],
        ['Класс УТ', domain.sout.class],
        ['Дата СОУТ', domain.sout.date],
        ['Пересмотр до', domain.sout.nextDate],
      ],
    },
    {
      title: 'Оценка рисков',
      status: domain.riskAssessment.status,
      linkTo: `/risks?employeeId=${employeeId}`,
      rows: [
        ['Уровень (балл)', `${domain.riskAssessment.level} (${domain.riskAssessment.score})`],
        ['План', domain.riskAssessment.plan],
        ['Статус', medLabel[domain.riskAssessment.status] ?? domain.riskAssessment.status],
      ],
    },
  ];
}
